import React, { useContext, useEffect,  useRef, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import { Button } from "../../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import { LabelProps } from "../../../../../../utils/types";
import { Label } from "../../../../../../stories/Label/Label";
import Input from "../../../../../../stories/Input/Input";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../styles/AutocompleteStyles";
import { TextField } from "@mui/material";
import { IObjectKeys } from "../../../../../../utils/formTypes";
import { Keys } from "../../../../../../utils/Enum.keys";
import {
  handleFormEvent,
  handleMUISelectEvent,
} from "../../../../../../utils/UtilFunctions";
import { Form, Formik, FormikProps } from "formik";
import { negotiationDetailsValidation } from "../../../../../../utils/validationSchema";
import InputNumber from "../../../../../common/Input/InputNumber";
import { AppContext } from "../../../../../../context/context";
import { useLazyQuery, useMutation } from "@apollo/client";
import { RfqTrnSupplyByNode } from "./queries/queries";
import {
  RfqTrnSupplyByNodeVar,
  UpdateRfqTrnSupplyNegoResult,
  UpdateRfqTrnSupplyNegoVar,
  itemInitialValuesType,
  vendorQuotedDetailsInitialValuesType,
} from "./queries/types";

import { AtsRfqTrnSupplyQuotationDetails } from "../queries/types";
import LoggedEmployee from "../../../../../../customComponents/LoggedEmployee";
import { UpdateRfqTrnSupplyNego } from "./queries/mutations";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { emptyMessage } from "../../../../../../utils/constants";
import { LicenseTypes, Operation } from "../../../../../../utils/Enum.types";
import LoadingModal from "../../../../../pages/LoadingModal";
import MessageModal from "../../../../../../customComponents/MessageModal";
import Navbar from "../../../../../common/layout/Navbar";
import useLabels from "../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../json/useFormJson";



export const itemInitialValues: itemInitialValuesType = {
  item_desc: "",
  required_qty: 0,
  terms: "",
  payment_terms: "",
};

export const vendorQuotedDetailsInitialValues: vendorQuotedDetailsInitialValuesType =
  {
    quoted_company: "",
    vendor_item_desc: "",
    quoted_qty: 0,
    rate: 0,
    any_other_charges: false,
    tax_perc: 0,
    total_amount: 0,
    others: 0,
    net_quoted: 0,
    remarks: "",
  };

const NegotiateDetails = () => {
  const navigate = useNavigate();
  const { state } = useContext(AppContext);
  
  const { customer_id, rfqTrnSupplyId } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
const {FillNegotiationDetails}=useFormJson();
  const [message, setMessage] = useState(emptyMessage);
  const [item, setItem] = useState<itemInitialValuesType>(itemInitialValues);
  const [remark, setRemark] = useState("");
  const [vendorQuotedDetails, setVendorQuotedDetails] =
    useState<vendorQuotedDetailsInitialValuesType>(
      vendorQuotedDetailsInitialValues
    );

  const [rfqTrnSupplyByNode, { loading }] = useLazyQuery<
    { node: AtsRfqTrnSupplyQuotationDetails },
    RfqTrnSupplyByNodeVar
  >(RfqTrnSupplyByNode);

  const [updateRfqTrnSupplyNego, { loading: UpdateRfqTrnSupplyNegoLoading }] =
    useMutation<UpdateRfqTrnSupplyNegoResult, UpdateRfqTrnSupplyNegoVar>(
      UpdateRfqTrnSupplyNego,
      {
        onError: (e) => {
          setMessage({
            message: e.message,
            flag: true,
            operation: Operation.NONE,
          });
        },
      }
    );

  interface negotiateDetailsFormDataType extends IObjectKeys {
    rfqTrnSupplyId: number;
    negoStatus: boolean;
    negoRate: number;
    negoQty: number;
    negoOther: number;
    negoTaxable: number;
    negoTax: number;
    negoDelvChrg: number;
    negoInstChrg: number;
    negoValue: number;
    negotiation_by: string;
  }

  const negotiateDetailsInitialValues: negotiateDetailsFormDataType = {
    rfqTrnSupplyId: 0,
    negoStatus: false,
    negoRate: 0,
    negoQty: 0,
    negoOther: 0,
    negoTaxable: 0,
    negoTax: 0,
    negoDelvChrg: 0,
    negoInstChrg: 0,
    negoValue: 0,
    negotiation_by: "",
  };
  const [formData, setFormData] = useState<negotiateDetailsFormDataType>(
    negotiateDetailsInitialValues
  );

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<negotiateDetailsFormDataType>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    switch (name) {
      case "negoQty":
        changeValue(
          Number(formData.negoRate),
          Number(value),
          Number(formData.negoDelvChrg),
          Number(formData.negoInstChrg),
          Number(formData.negoOther),
          Number(formData.negoTax),
          e
        );
        meta.handleChange(e);
        break;
      case "negoRate":
        changeValue(
          Number(value),
          Number(formData.negoQty),
          Number(formData.negoDelvChrg),
          Number(formData.negoInstChrg),
          Number(formData.negoOther),
          Number(formData.negoTax),
          e
        );
        meta.handleChange(e);
        break;
      case "negoDelvChrg":
        changeValue(
          Number(formData.negoRate),
          Number(formData.negoQty),
          Number(value),
          Number(formData.negoInstChrg),
          Number(formData.negoOther),
          Number(formData.negoTax),
          e
        );
        meta.handleChange(e);
        break;
      case "negoInstChrg":
        changeValue(
          Number(formData.negoRate),
          Number(formData.negoQty),
          Number(formData.negoDelvChrg),
          Number(value),
          Number(formData.negoOther),
          Number(formData.negoTax),
          e
        );
        meta.handleChange(e);
        break;
      case "negoOther":
        changeValue(
          Number(formData.negoRate),
          Number(formData.negoQty),
          Number(formData.negoDelvChrg),
          Number(formData.negoInstChrg),
          Number(value),
          Number(formData.negoTax),
          e
        );
        meta.handleChange(e);
        break;
      case "negoTax":
        changeValue(
          Number(formData.negoRate),
          Number(formData.negoQty),
          Number(formData.negoDelvChrg),
          Number(formData.negoInstChrg),
          Number(formData.negoOther),
          Number(value),
          e
        );
        meta.handleChange(e);
        break;
      default:
        setFormData(() => ({
          ...formData,
          [name]: value,
        }));
        meta.handleChange(e);
        break;
    }
  };

  const changeValue = (
    negoRate: number,
    negoQty: number,
    negoDelvChrg: number,
    negoInstChrg: number,
    negoOther: number,
    negoTax: number,
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    const taxable =
      Number(negoRate) * Number(negoQty) +
      Number(negoDelvChrg) +
      Number(negoInstChrg) +
      Number(negoOther);

    const taxesValue = (Number(negoTax) / 100) * taxable;

    const netValue = taxable + taxesValue;

    setFormData({
      ...formData,
      [name]: value,
      negoValue: taxesValue,
    });
  };

  const handleSubmit = async () => {
    const inputData = () => {
      const { negotiation_by, ...rest } = formData;
      return { negoRemarks: remark, ...rest };
    };
    if (rfqTrnSupplyId && state.ActiveFinYr && customer_id) {
      updateRfqTrnSupplyNego({
        variables: {
          
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          user_details,
          input: [inputData()],
        },
      }).then(({ data }) => {
        if (data) {
          setMessage({
            message: "Update negotiation successfully",
            flag: true,
            operation: Operation.UPDATE,
          });
        }
      });
    }
  };

  useEffect(() => {
    if (rfqTrnSupplyId) {
      rfqTrnSupplyByNode({
        variables: {
          
          id: rfqTrnSupplyId,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          const nodeData = data.node;

          const totalAmount =
            nodeData.quotedQty * nodeData.quotedRate +
            nodeData.quotedInstChrg +
            nodeData.quotedDelvChrg +
            nodeData.quotedOther;

          const netAmount = (nodeData.quotedTax / 100) * totalAmount;
          setItem({
            item_desc: nodeData.rfqTrn.udfItemDesc,
            required_qty: nodeData.rfqTrn.mrf_trn_details.reqQty,
            terms: nodeData.rfqTrn.itemTerms,
            payment_terms: nodeData.rfqTrn.itemPaymentTerms,
          });

          setVendorQuotedDetails({
            quoted_company: nodeData.supplierDetails.desc,
            vendor_item_desc: nodeData.quotedDesc,
            quoted_qty: nodeData.quotedQty,
            rate: nodeData.quotedRate,
            any_other_charges: nodeData.quotedAnyChanges,
            tax_perc: nodeData.quotedTax,
            total_amount: totalAmount,
            others: nodeData.quotedOther,
            net_quoted: netAmount,
            remarks: nodeData.quotedRemarks,
          });
          setFormData({
            rfqTrnSupplyId: rfqTrnSupplyId ? rfqTrnSupplyId : 0,
            negoStatus: nodeData.negoStatus,
            negoRate: nodeData.negoRate,
            negoQty: nodeData.negoQty,
            negoOther: nodeData.negoOther,
            negoTaxable: nodeData.negoTaxable,
            negoTax: nodeData.negoTax,
            negoDelvChrg: nodeData.negoDelvChrg,
            negoInstChrg: nodeData.negoInstChrg,
            negoValue: nodeData.negoValue,
            negotiation_by: "",
          });
          setRemark(nodeData.negoRemarks);
        }
      });
    }
  }, [rfqTrnSupplyByNode, state.rfqTrnSupplyId]);

  const handleClear = () => {
    setFormData(negotiateDetailsInitialValues);
  };

  const handleClose = () => {
    setMessage(emptyMessage);
    if (message.operation !== Operation.NONE) {
      handleClear();
    }
  };
const {itemLabel,ledgerLabel}=useLabels();
  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} />
      <Title>Fill Negotiation Details</Title>
      {/* use below div for forms */}
      <Formik
        initialValues={formData}
        validationSchema={negotiationDetailsValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form className="fill-negotiate-details">
              <div className="fill-negotiate-details__block row g-0">
                <div className="col fill-negotiate-details__block--frame">
                  <Title variant="subtitle1">{itemLabel} Details</Title>
                  <div className="fill-negotiate-details__block--frame--details">
                    {FillNegotiationDetails.ItemDetails.map(
                      (label: LabelProps, key: React.Key) => {
                        if (label.inputName === "required_qty") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{label.labelName}</Label>
                                <Input value={item[label.inputName]} disabled />
                              </div>
                            </React.Fragment>
                          );
                        } else
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{label.labelName}</Label>
                                <TextArea
                                  value={item[label.inputName]}
                                  disabled
                                  rows={2}
                                />
                              </div>
                            </React.Fragment>
                          );
                      }
                    )}
                  </div>
                </div>
                <div className="col fill-negotiate-details__block--frame">
                  <Title variant="subtitle1">{ledgerLabel} Quoted Details</Title>
                  <div className="fill-negotiate-details__block--frame--details">
                    {FillNegotiationDetails.VendorQuotedDetails.map(
                      (label: LabelProps, key: React.Key) => {
                        if (label.inputName === "remarks") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{label.labelName}</Label>
                                <TextArea
                                  value={vendorQuotedDetails[label.inputName]}
                                  disabled
                                  rows={2}
                                />
                              </div>
                            </React.Fragment>
                          );
                        } else
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{label.labelName}</Label>
                                <Input
                                  value={vendorQuotedDetails[label.inputName]}
                                  disabled
                                />
                              </div>
                            </React.Fragment>
                          );
                      }
                    )}
                  </div>
                </div>
                <div className="col fill-negotiate-details__block--form">
                  <Title variant="subtitle1">Fill Negotiation Details</Title>
                  <div className="fill-negotiate-details__block--frame--details">
                    <div className="fill-negotiate-details__block--form--details">
                      {FillNegotiationDetails.NegotiationDetails.map(
                        (label: LabelProps, key: React.Key) => {
                          if (label.inputName === "negotiation_by") {
                            return (
                              <React.Fragment key={key}>
                                <div className="label-grid">
                                  <Label>{label.labelName}</Label>
                                  <LoggedEmployee />
                                </div>
                              </React.Fragment>
                            );
                          } else if (label.dataType === "number") {
                            return (
                              <React.Fragment key={key}>
                                <div className="label-grid">
                                  <Label>{label.labelName}</Label>
                                  <InputNumber
                                    value={formData[label.inputName]}
                                    onChange={(
                                      e: React.ChangeEvent<HTMLInputElement>
                                    ) => {
                                      handleValueChange(e, meta);
                                    }}
                                    name={label.inputName}
                                    required={label.required}
                                    maxLength={label.maxLength}
                                    onKeyDown={handleFormEvent}
                                  />
                                </div>
                                {meta.touched[label.inputName] &&
                                meta.errors[label.inputName] ? (
                                  <div className="label-grid">
                                    <span />
                                    <span className="nodata">
                                      {meta.errors[label.inputName]}
                                    </span>
                                  </div>
                                ) : null}
                              </React.Fragment>
                            );
                          } else if (label.inputName === "negoStatus") {
                            return (
                              <React.Fragment key={key}>
                                <div className="label-grid">
                                  <Label>{label.labelName}</Label>
                                  <FormAutocomplete
                                    className={formClasses.inputRoot}
                                    options={["yes", "no"]}
                                    onKeyDown={(e) => {
                                      if (e.key === Keys.ENTER) {
                                        e.preventDefault();
                                        handleMUISelectEvent(e);
                                      }
                                    }}
                                    value={
                                      formData[label.inputName] ? "yes" : "no"
                                    }
                                    onChange={(e, newValue) => {
                                      if (newValue) {
                                        setFormData({
                                          ...formData,
                                          negoStatus:
                                            (newValue as string) === "yes"
                                              ? true
                                              : false,
                                        });
                                      } else {
                                        setFormData({
                                          ...formData,
                                          negoStatus: false,
                                        });
                                      }
                                    }}
                                    openOnFocus
                                    forcePopupIcon
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        fullWidth
                                        required
                                        className={formClasses.formControlRoot}
                                      />
                                    )}
                                  />
                                  {meta.errors[label.inputName] &&
                                  meta.touched[label.inputName] ? (
                                    <div className="label-grid">
                                      <span />
                                      <span className="nodata">
                                        {meta.errors[label.inputName]}
                                      </span>
                                    </div>
                                  ) : null}
                                </div>
                              </React.Fragment>
                            );
                          } else if (label.dataType === "textarea") {
                            return (
                              <React.Fragment key={key}>
                                <div className="label-grid">
                                  <Label>{label.labelName}</Label>
                                  <TextArea
                                    rows={2}
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                  />
                                </div>
                              </React.Fragment>
                            );
                          } else
                            return (
                              <React.Fragment key={key}>
                                <div className="label-grid">
                                  <Label>{label.labelName}</Label>
                                  <Input
                                    type="text"
                                    value={formData[label.inputName]}
                                    name={label.inputName}
                                    onChange={(
                                      e: React.ChangeEvent<HTMLInputElement>
                                    ) => {
                                      handleValueChange(e, meta);
                                    }}
                                    required={label.required}
                                    autoFocus={label.autoFocus}
                                  />
                                </div>

                                {meta.errors[label.inputName] &&
                                meta.touched[label.inputName] ? (
                                  <div className="label-grid">
                                    <span />
                                    <span className="nodata">
                                      {meta.errors[label.inputName]}
                                    </span>
                                  </div>
                                ) : null}
                              </React.Fragment>
                            );
                        }
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <Button mode="save" type="submit"/>
              <Button mode="clear" onClick={handleClear} />
              <Button mode="back" onClick={() => navigate(-1)} />
            </Form>
          );
        }}
      </Formik>
      <LoadingModal flag={loading || UpdateRfqTrnSupplyNegoLoading} />
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </>
  );
};

export default NegotiateDetails;
